var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-Scroll-To"})
}
var staticRenderFns = []

export { render, staticRenderFns }